<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem full">
    <el-form-item label="表格中船期信息项（勾选后，该字段信息将会记录在结果表格中）" required>
      <el-checkbox-group v-model="form.requiredFields" style="width: 100%;">
        <el-row style="width: 100%;">
          <el-col :span="6" v-for="(item, index) in requiredFields.slice(0, 3)">
            <el-checkbox :label="item?.fieldDesc" :value="item?.fieldName" :checked="true" :disabled="true" />
          </el-col>
          <el-col :span="6" style="display: flex; align-items: center;">
            <MoreSetting @change="flag => showAllOptions = flag" />
          </el-col>
        </el-row>

        <el-row style="width: 100%; overflow: hidden;" :style="{ height: showAllOptions ? 'auto' : 0 }">
          <el-col :span="6" v-for="(item, index) in requiredFields.slice(3, requiredFields.length)">
            <el-checkbox :label="item?.fieldDesc" :value="item?.fieldName" :checked="true" :disabled="true" />
          </el-col>
        </el-row>
      </el-checkbox-group>

      <el-checkbox-group v-model="form.optionalFields" style="width: 100%;">
        <el-row style="width: 100%;">
          <el-col :span="6" v-for="(item, index) in optionalFields">
            <el-checkbox :label="item?.fieldDesc" :value="item?.fieldName" />
          </el-col>
        </el-row>
      </el-checkbox-group>
    </el-form-item>
  </div>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import MoreSetting from '../moresetting/index';

  const emits = defineEmits([ 'change' ]);

  const showAllOptions = ref(false)

  const form = ref({})
  watch(() => form.value, () => {
    emits('change', form.value)
  }, { deep: true });

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  });

  const requiredFields = ref([]);
  const optionalFields = ref([]);
  const init = () => {
    console.log('props.data------', props.data);
    requiredFields.value = [...props.data.requiredFields];
    optionalFields.value = [...props.data.optionalFields];
    optionalFields.value.map(item => {
      if(item.checked == 2) {
        form.value.optionalFields = form.value.optionalFields || []
        form.value.optionalFields.push(item.fieldName);
      }
    })
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });
</script>

<style scoped lang="less">
  @import "./index.less";
</style>